import React from 'react'
import './style.css'


const CourseAuthor = (props) => {
    return(
        <div className="course-author container">
            {props.children}
        </div>
    )

}

export default CourseAuthor


// WEBPACK FOOTER //
// ./src/components/_courses/CourseAuthor/index.js